import React from 'react';

import {Cell} from '@pb/kit-component-data-table-v2';

import {
    mainColumnCell,
    mainColumnCellAssigned,
    mainColumnCellLabel,
} from './main-column-cell.module.styl';

import type {CellOptions} from '@pb/kit-component-data-table-v2';

type Props = {
    children: React.ReactNode,
    cellOptions: CellOptions,
};

export const MainColumnAssignedResourceCell = ({children, cellOptions}: Props) => (
    <Cell {...cellOptions}>
        <div className={mainColumnCell}>
            <div style={{width: 50}}/>
            <div className={`${mainColumnCellLabel} ${mainColumnCellAssigned}`}>
                {children}
            </div>
        </div>
    </Cell>
);
